import React from 'react';
import { ETabId } from '../services/tab-configurations/tab-types';

export const PageContext = React.createContext(ETabId.Global);

export const usePageContext = () => React.useContext(PageContext);
